import React from "react";
import { Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { FaDatabase, FaInfoCircle } from "react-icons/fa";
import { Icon } from "../../../../../components/common/Icon";
import { ChatbotFormData } from "../types";

interface DatabaseTabProps {
  formData: ChatbotFormData;
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => void;
}

const DatabaseTab: React.FC<DatabaseTabProps> = ({
  formData,
  handleInputChange,
}) => {
  const { t } = useTranslation();

  return (
    <div className="tab-pane-content">
      <div className="section-header">
        <Icon icon={FaDatabase} className="section-icon" />
        <h5>{t("database_integration")}</h5>
      </div>

      <Form>
        <Form.Group className="form-group-custom">
          <Form.Label className="form-label-custom">
            <Icon icon={FaDatabase} className="me-2" />
            {t("database_metadata_endpoint")}
          </Form.Label>
          <Form.Control
            type="url"
            name="db_metadata_endpoint"
            value={formData.db_metadata_endpoint}
            onChange={handleInputChange}
            placeholder="https://api.example.com/metadata"
            className="form-control-custom"
          />
          <Form.Text className="form-text-custom">
            <Icon icon={FaInfoCircle} className="me-1" />
            {t("url_endpoint_for_retrieving_database_schema_metadata")}
          </Form.Text>
        </Form.Group>

        <Form.Group className="form-group-custom">
          <Form.Label className="form-label-custom">
            <Icon icon={FaDatabase} className="me-2" />
            {t("database_query_endpoint")}
          </Form.Label>
          <Form.Control
            type="url"
            name="db_query_endpoint"
            value={formData.db_query_endpoint}
            onChange={handleInputChange}
            placeholder="https://api.example.com/query"
            className="form-control-custom"
          />
          <Form.Text className="form-text-custom">
            <Icon icon={FaInfoCircle} className="me-1" />
            {t("url_endpoint_for_executing_database_queries")}
          </Form.Text>
        </Form.Group>
      </Form>
    </div>
  );
};

export default DatabaseTab;



